import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router'; // Importa Router
import { of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { EMPTY } from 'rxjs';
import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import * as chatActions from '../store/actions/chat.action'
import * as chatSelectors from '../store/selectors/chat.selector'
import { ChatServerService } from '../services/chat-server.service';
import * as currentOrderSelector from '../../orders/store/selectors/orders.selector'
import { ToastrService } from 'ngx-toastr';
import { from } from 'rxjs';
import { SseService } from '../services/server-sent-events.service';
import { CitiesService } from '../../cities/services/cities.service';
import { PendingMessagesService } from '../services/pending-messages.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ChatEffects {
  sseServerUrl = environment.sseServerUrl;

  file: any;
  userSelectedCityId = this.citiesService.getUserSelectedCityId();

  
  loadChat$ = createEffect(() => this.actions$.pipe(
    ofType(chatActions.loadChat),
    withLatestFrom(this.store.pipe(select(currentOrderSelector.selectCurrentOrderId))),
    mergeMap(([action, id]) => this.chatServerService.loadChat(id).pipe(
      mergeMap(messages => [
        chatActions.loadChatSuccess({ messages: messages.messages }),
        chatActions.clearMessageRead({ service_id: id })
      ]),
      tap(() => this.pendingMessagesService.clearPendingMessages(id)),
      catchError(error => {
        console.error('Server chat error:', error);
        return EMPTY;
      })
    ))
  ));

      sendMessage$ = createEffect(() =>
        this.actions$.pipe(
          ofType(chatActions.sendMessage),
          mergeMap(action =>
            this.chatServerService.sendMessage(action.message).pipe(
              tap(message => console.log('Server send message response:', message)),
              map(message => {
               
                this.toastr.success('Mensaje enviado');
               
                return chatActions.sendMessageSuccess({ message }); 
              }),
              catchError(error => {
               
                this.toastr.error('Error enviando el mensaje, verifique su conexión a internet');
                
                return of(chatActions.sendMessageFailure({ error })); 
              })
            )
          )
        )
      );

      reloadMessages$ = createEffect(() =>
        this.actions$.pipe(
          ofType(chatActions.sendMessageSuccess),
          map(() => chatActions.loadChat())
        )
      );

      getMediaUploadUrl$ = createEffect(() =>
        this.actions$.pipe(
          ofType(chatActions.getMediaUploadUrl),
          mergeMap(action =>
            this.chatServerService.getMediaUploadUrl(action.service_id, action.file_name).pipe(
              tap(mediaUploadDetails => this.file = action.file),
              map(mediaUploadDetails => {
              
                return chatActions.getMediaUploadUrlSuccess({ mediaUploadDetails })
              }),
              catchError(error => {
                this.toastr.error('Error enviando multimedia, verifique su conexión a internet');
                return of(chatActions.getMediaUploadUrlFailure({ error }));
              })
            )
          )
        )
      );

     //with axios
      uploadFileToServer$ = createEffect(() =>
        this.actions$.pipe(
          ofType(chatActions.getMediaUploadUrlSuccess),
          mergeMap(action =>
            from(this.chatServerService.uploadMediaToS3(action.mediaUploadDetails.pre_signed_put_url, this.file, action.mediaUploadDetails.content_type)).pipe(
              map(() => {
                // this.toastr.success('Multimedia subida');

                return  chatActions.uploadFileToServerSuccess({mediaUploadDetails: action.mediaUploadDetails})
              }),
              catchError(error => of(chatActions.uploadFileToServerFailure({ error })))
            )
          )
        )
      );
      
      sendMediaMessage$ = createEffect(() =>
        this.actions$.pipe(
          ofType(chatActions.uploadFileToServerSuccess),
          withLatestFrom(this.store.pipe(select(chatSelectors.selectMediaMessage))),
          mergeMap(([action, mediaMessage]) => {
           
            if (!mediaMessage) {
              return of(chatActions.sendMediaMessageFailure({ error: null }));
            }
            // Actualizar los detalles de media en mediaMessage con los obtenidos de mediaUploadDetails
            const updatedMediaMessage = {
              ...mediaMessage,
              content: {
                ...mediaMessage.content,
                media: {
                  ...mediaMessage.content.media,
                  mimetype: action.mediaUploadDetails.content_type,
                  object_key: action.mediaUploadDetails.object_key
                },
                image: null,
                audio: null,
              }
            };
            return this.chatServerService.sendMediaMessage(updatedMediaMessage).pipe(
              map(() => {
                this.toastr.success('Multimedia enviada');
              
                return chatActions.sendMediaMessageSuccess({ mediaMessage: updatedMediaMessage });
              }),
              catchError(error => {
                this.toastr.error('Error enviando mensaje multimedia, verifique su conexión a internet');
                return of(chatActions.sendMediaMessageFailure({ error }));
              })
            );
          })
        )
      );

      // startSseConnection$ = createEffect(() =>
      //   this.actions$.pipe(
      //     ofType(chatActions.startSseConnection),
      //     mergeMap(() =>
      //       this.sseService.getServerSentEvent(`https://dev-sse-server.samalogistica3.com/subscribe/${this.userSelectedCityId}`).pipe(
      //         map(event => chatActions.receiveMessage({ message: JSON.parse(event.data) })),
      //         catchError(error => {
      //           this.toastr.error('No se pudo hacer la conexion para recibir mensajes, verifique su conexión a internet');
      //           return of(chatActions.startSseConnectionFailure({ error }));
      //         })
      //       )
      //     )
      //   )
      // );
    
      receiveMessages$ = createEffect(() =>
        this.sseService
          .getServerSentEvent(
            `${this.sseServerUrl}/subscribe/${this.userSelectedCityId}`
          )
          .pipe(
            map((event: MessageEvent) => {
              const service_id: number = Number(event.data); // Convertir directamente a número
             
              return chatActions.receiveMessage({ service_id });
            }),
            catchError((error) => {
              // this.toastr.error(
              //   'No se están recibiendo mensajes, verifique su conexión a internet'
              // );
             
              return of(chatActions.receiveMessageFailure({ error }));
            })
          )
      );

      refreshChat$ = createEffect(() =>
        this.actions$.pipe(
          ofType(chatActions.receiveMessage),
          mergeMap(action =>
            this.chatServerService.loadChat(action.service_id).pipe(
              map(messages => chatActions.loadChatSuccess({ messages: messages.messages })),
              catchError(error => {
                console.error('Server chat error:', error);
                return EMPTY;
              })
            )
          )
        )
      );

  constructor(
    private actions$: Actions,
    private store: Store,
    private chatServerService: ChatServerService,
    private toastr: ToastrService,
    private sseService: SseService,
    private citiesService: CitiesService,
    private pendingMessagesService: PendingMessagesService
  ) {}

}